export const fullDateWithDashes = 'yyyy-MM-dd';
export const fullDateWithDots = 'dd.MM.yy';
